import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import LoadingSpinner from 'shared/components/loading/loading-spinner'

import { useEmit } from './socket/socket-context'

export type LoggedInUserStateType = {
  id: string | null
  fullname: string | null
  userPhone: string | null
  userDomain: string | null
  teamName: string | null
  teamId?: string | null
  userPosition: string | null
  userPositionLevel: string | null
  userProductType: string | null
  imageUrl: string | null
}

type ContextType = {
  loggedInUser: LoggedInUserStateType | null
  setLoggedInUser: React.Dispatch<
    React.SetStateAction<LoggedInUserStateType | null>
  >
}

const initialState: ContextType = {
  loggedInUser: {
    id: null,
    fullname: null,
    userPhone: null,
    userDomain: null,
    teamName: null,
    userPosition: null,
    userPositionLevel: null,
    userProductType: null,
    imageUrl: null,
  },
  setLoggedInUser: () => {},
}

export const loggedInUserContext = createContext(initialState)

type ProviderProps = {
  children?: ReactNode
}

export const LoggedInUserContextProvider = ({ children }: ProviderProps) => {
  const [loggedInUser, setLoggedInUser] =
    useState<LoggedInUserStateType | null>(null)
  const emit = useEmit()

  useEffect(() => {
    emit('login')
      .then((userInfo: any) => {
        console.log('login as extension ', userInfo)
        if (userInfo) {
          setLoggedInUser(userInfo)
        }
      })
      .catch((e) => {
        console.log('error login', e)
      })
  }, [])

  return (
    <loggedInUserContext.Provider
      value={{
        loggedInUser,
        setLoggedInUser,
      }}
    >
      {children}
    </loggedInUserContext.Provider>
  )
}

export const useLoggedInUser = () => useContext(loggedInUserContext)

export const LoadingLoggedIdUser = ({
  children,
  showLoading = true,
}: {
  children: ReactNode
  showLoading?: boolean
}) => {
  const { loggedInUser } = useLoggedInUser()

  if (loggedInUser?.id) return <>{children}</>

  return showLoading ? (
    <div className="flex items-center justify-center w-screen h-screen fixed inset-0">
      <LoadingSpinner />
    </div>
  ) : null
}
